import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import BankFieldPreview from './BankFieldPreview';

interface PreviewBankFieldModalProps {
  open: boolean;
  onClose: () => void;
  fieldData: any; // Using any for flexibility or match IBankForm
}

const PreviewBankFieldModal: React.FC<PreviewBankFieldModalProps> = ({
  open,
  onClose,
  fieldData
}) => {
  if (!fieldData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Preview Field: {fieldData.field_name}</DialogTitle>
      <DialogContent>
        <BankFieldPreview
          label={fieldData.field_name}
          type={fieldData.field_type}
          required={fieldData.is_required}
          options={fieldData.field_options || []}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={{ bgcolor: '#5E8E7E', '&:hover': { bgcolor: '#4A7A6A' } }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewBankFieldModal;
